import { useId } from 'react';
import { JvmSettingsSchema, type JvmSettings } from '@mcpanel/core';
export function JvmSettingsFields({
  value,
  onChange,
  disabled = false,
}: {
  value: JvmSettings;
  onChange: (value: JvmSettings) => void;
  disabled?: boolean;
}) {
  const id = useId();
  const parsed = JvmSettingsSchema.safeParse(value);
  return (
    <div className="stack">
      <div className="field">
        <label htmlFor={id + '-flags'}>Aikar's flags</label>
        <select
          data-search-id="jvm-flags"
          id={id + '-flags'}
          className="input"
          value={value.flags}
          disabled={disabled}
          onChange={(e) => onChange({ ...value, flags: e.target.value as JvmSettings['flags'] })}
        >
          <option value="aikar">有効</option>
          <option value="none">無効</option>
        </select>
      </div>
      <div className="field">
        <label htmlFor={id + '-args'}>追加の引数（1 行に 1 つ）</label>
        <textarea
          data-search-id="jvm-args"
          id={id + '-args'}
          className="input jvm-args"
          rows={8}
          wrap="soft"
          value={value.extraArgs.join('\n')}
          disabled={disabled}
          aria-invalid={!parsed.success}
          aria-describedby={id + '-errors'}
          onChange={(e) => onChange({ ...value, extraArgs: e.target.value === '' ? [] : e.target.value.split('\n') })}
        />
        <div id={id + '-errors'} role={parsed.success ? undefined : 'alert'}>
          {!parsed.success && (
            <ul className="field-errors">
              {parsed.error.issues.map((issue, i) => {
                const line = issue.path[0] === 'extraArgs' ? issue.path[1] : undefined;
                return (
                  <li key={i}>
                    {typeof line === 'number' && (
                      <>
                        行 {line + 1}: <code>{value.extraArgs[line] || '（空行）'}</code> —{' '}
                      </>
                    )}
                    {issue.message}
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
